import axios from 'axios';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';

const DetailedInformation = () => {
  const { id } = useParams();

  const { REACT_APP_API_HOST } = process.env;
  const { data } = useQuery(['detailed-information'], async () => {
    const { data } = await axios({
      method: 'get',
      url: `${REACT_APP_API_HOST}/v1/timeaway/${id}`,
    });

    return data?.timeaway;
  });

  const renderDecision = (decision: string) => {
    switch (decision) {
      case 'pending':
        return 'Pending';

      case 'approved':
        return 'Approved';

      default:
        return 'Unknown';
    }
  };

  return (
    <>
      <div className="rounded-lg-white col-span-4 overflow-hidden bg-white shadow">
        <div className="px-8 py-8">
          <div className="px-4 sm:px-0">
            <h3 className="text-base font-semibold leading-7 text-gray-900">
              Request Information
            </h3>
            <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">
              Time off request details and information.
            </p>
          </div>
          <div className="mt-6 border-t border-gray-100">
            <dl className="divide-y divide-gray-100">
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Applicant
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {data?.applicant}
                </dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Decision by
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {data?.decision_by}
                </dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Request for
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {data?.request_for}
                </dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Status
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {renderDecision(data?.status)}
                </dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Days requested
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {data?.days_requested}
                </dd>
              </div>
              <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                <dt className="text-sm font-medium leading-6 text-gray-900">
                  Description
                </dt>
                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                  n/a
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </>
  );
};

const Heading = () => {
  const { user } = useUser();

  return (
    <div className="pb-5">
      <h3 className="text-base font-semibold leading-6 text-gray-900">
        Timeaway for {user?.firstName} {user?.lastName}
      </h3>
    </div>
  );
};

function EventRoute() {
  return (
    <>
      <Heading />
      <div className="grid grid-cols-2 gap-4">
        <DetailedInformation />
        {/*<Timeline /> */}
      </div>
    </>
  );
}

export const ProtectedEventRoute = EventRoute;
